
<div class="card drop-shadow border-radius  p-4 center mb-4" style="width: 350px; ">
    <h5 class="card-title m-3 center"><strong>Buyer's Benefit Calculator</strong></h5>
    <div class="h5">Purchase Price: {{value | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
    <input type="number" [(ngModel)]="value" placeholder="value | currency : 'USD' : 'symbol' : '1.0-0'" class="mb-4">
    <input type="range" min="50000" max="1500000" [(ngModel)]="value" class="mb-4">
    <div class="row mb-3">
        <div class="col-sm-12" style="text-align: center;">
            <div class="btn-group btn-group-toggle " data-toggle="buttons">
                <label class="btn btn-primary active btn-sm" (click)="isNotVet()">
                    <input type="radio" name="options" id="option2" autocomplete="off"> Non-Veteran
                </label>
                <label class="btn btn-primary  btn-sm" (click)="isVet()">
                    <input type="radio" name="options" id="option1" autocomplete="off" checked> Veteran
                </label>
               

            </div>
        </div>
    </div>
<div *ngIf="nonvet == true">
    <div class="mb-3">
        <h6 class="center bold">Rebate To The Buyer:<br>
            <strong style="font-weight: 900; font-size: xx-large;">{{value * .0057| currency : 'USD' : 'symbol' :
                '1.0-0'}}</strong>
        </h6>

    </div>
    <div class="mb-3">
        <h6>USO Donation:<br>
            <strong style="font-weight: 900; font-size: xx-large;">
                {{value * .0006 | currency : 'USD' : 'symbol' : '1.0-0'}}
            </strong>
        </h6>
    </div>
    <div>

        <h6 class="center bold">Total Buyer's Benefit:<br>
            <strong style="font-weight: 900; font-size: xx-large;">{{value * .0063| currency : 'USD' : 'symbol' :
                '1.0-0'}}</strong>
        </h6>
    </div>
    <div class="small muted mt-3" style="font-size: .6em;">*Estimated rebate is assuming a 3% selling agent commission
        paid by the seller.</div>
</div>
<div *ngIf="vet == true">
    <div class="mb-3">
        <h6 class="center bold">Rebate To The Veteran:<br>
            <strong style="font-weight: 900; font-size: xx-large;">{{value * .0066| currency : 'USD' : 'symbol' :
                '1.0-0'}}</strong>
        </h6>

    </div>
    <div class="mb-3">
        <h6>USO Donation:<br>
            <strong style="font-weight: 900; font-size: xx-large;">
                {{value * .0009 | currency : 'USD' : 'symbol' : '1.0-0'}}
            </strong>
        </h6>
    </div>
    <div>

        <h6 class="center bold">Total Buyer's Benefit:<br>
            <strong style="font-weight: 900; font-size: xx-large;">{{value * .0075| currency : 'USD' : 'symbol' :
                '1.0-0'}}</strong>
        </h6>
    </div>
    <div class="small muted mt-3" style="font-size: .6em;">*Estimated rebate is assuming a 3% selling agent commission
        paid by the seller.</div>
</div>
</div>